import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-post-booking-followup',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './post-booking-followup.component.html',
  styleUrls: ['./post-booking-followup.component.scss'],
})
export class PostBookingFollowupComponent {
  /** Set once the user answers — shows the confirmed response. */
  @Input() answer?: 'yes' | 'no';
  @Input() disabled = false;

  @Output() answered = new EventEmitter<'yes' | 'no'>();

  onYes(): void { this.answered.emit('yes'); }
  onNo(): void  { this.answered.emit('no');  }
}
